import { host_v2 } from '../utilities/requests';

const menus = {
    examination:[
        {
            "text": "تنظیمات",
            "items": [
                {
                    "text": "اعتراض‌ها",
                    "action": "/reports/complaints/"
                },
                {
                    "text": "نظر‌های فهرست‌ها",
                    "action": "/examinations/catalogue-comments/"
                },
                {
                    "text": "نظر‌ها",
                    "action": "/examinations/comments/"
                },
                {
                    "text": "مشکلات",
                    "action": "/examinations/problems/"
                },
                {
                    "text": "اشتباهات",
                    "action": "/examinations/mistakes/"
                },
                {
                    "text": "پایه‌ها",
                    "action": "/examinations/grades/"
                }
            ]
        },
        {
            "text": "بانک سوال",
            "items": [
                {
                    "text": "سوالها",
                    "action": "/questions/"
                },
                {
                    "text": "درخت دانش",
                    "action": "/questions/science-tree/"
                },
                {
                    "text": "برچسبها",
                    "action": "/questions/labels-tree/"
                },
                {
                    "text": "گونه‌ها",
                    "action": "/questions/types/"
                },
                {
                    "text": "سختی‌ها",
                    "action": "/questions/levels/"
                }
            ]
        },
        {
            "text": "بانک آزمون",
            "items": [
                {
                    "text": "آزمون‌ها",
                    "action": "/examinations/"
                },
                {
                    "text": "گونه‌ها",
                    "action": "/examinations/types/"
                },
                {
                    "text": "اجرای آزمون‌ها",
                    "action": "/examination-execution/"
                }
            ]
        },
        {
            "text": "ثبت‌نام",
            "items": [
                {
                    "text": "دانش آموزان",
                    "action": "/students/"
                },
                {
                    "text": "مدرسه‌ها",
                    "action": "/schools/"
                },
                {
                    "text": "مدیران",
                    "action": "/managers/"
                },
                {
                    "text": "دبیران",
                    "action": host_v2 + "/Users/Teacher/Index?pageId=1"
                },
                {
                    "text": "نمایندگی‌ها",
                    "action": "/clients/"
                },
                {
                    "text": "ثبت نام در آزمون ",
                    "action": "/registrations/"
                }
            ]
        },
        {
            "text": "تستی",
            "items": [
                {
                    "text": "برگه‌خوان",
                    "action": "/multiple-choice-papers/reader/"
                },
                {
                    "text": "برگه‌های خراب",
                    "action": "/multiple-choice-papers/corrupt/"
                },
                {
                    "text": "بازبینی",
                    "action": "/multiple-choice-papers/"
                },
                {
                    "text": "تحلیل آزمون‌ها",
                    "action": "/analyze-examinations/"
                },
                {
                    "text": "کارنامه تلفیقی",
                    "action": "/analyze_consolidated/"
                },
                {
                    "text": "تحلیل شبیه‌ساز تلفیقی",
                    "action": "/analyze_shabih_saz_consolidated/"
                },
            ]
        },
        {
            "text": "تشریحی",
            "items": [
                {
                    "text": "برگه‌خوان",
                    "action": "/papers/reader/"
                },
                {
                    "text": "برگه‌های خراب",
                    "action": "/papers/corrupt/"
                },
                {
                    "text": "بازبینی",
                    "action": "/papers/"
                },
                {
                    "text": "مصحح‌ها",
                    "action": "/markers/"
                },
                {
                    "text": "جواب‌ها",
                    "action": "/answers/"
                },
                {
                    "text": "تصحیح‌ها",
                    "action": "/results/"
                }
            ]
        },
        {
            "text": "گزارش آزمون ها",
            "items": [
                {
                    "text": "تستی",
                    "action": "/reports/multiple-choice/"
                },
                {
                    "text": "تشریحی",
                    "action": "/reports/essay/examinations/"
                }
            ]
        }
    ],
    book:[
        {
            "text": "تنظیمات",
            "items": [
                {
                    "text": "دسته‌های کتاب",
                    "action": "/book/categories/"
                },
                {
                    "text": "کتاب‌ها",
                    "action": "/book/books/"
                },
                {
                    "text": "مؤلف‌ها",
                    "action": "/book/compilers/"
                },
                {
                    "text": "فیش‌ها",
                    "action": "/book/notes/"
                },
                {
                    "text": "نظر‌ها",
                    "action": "/book/comments/"
                },
                {
                    "text": "سوال و جواب",
                    "action": "/book/questions/"
                },
                {
                    "text": "اشتباهات",
                    "action": "/book/mistakes/"
                }
            ]
        },
        {
            "text": "چهارم",
            "items": [
                {
                    "text": "اضافه",
                    "action": "/book/new/?category=17"
                }
            ]
        },
        {
            "text": "پنجم",
            "items": [
                {
                    "text": "اضافه",
                    "action": "/book/new/?category=16"
                }
            ]
        },
        {
            "text": "ششم",
            "items": [
                {
                    "text": "آزمونستان ریاضی",
                    "action": "/book/7/0/introduction/"
                },
                {
                    "text": "استعداد تحلیلی",
                    "action": "/book/22/0/introduction/"
                },
                {
                    "text": "علوم تیزهوشان",
                    "action": "/book/37/0/introduction/"
                },
                {
                    "text": "ساندویچ هوش ششم",
                    "action": "/book/68/0/introduction/"
                },
                {
                    "text": "اضافه",
                    "action": "/book/new/?category=4"
                }
            ]
        },
        {
            "text": "هفتم",
            "items": [
                {
                    "text": "فیزیک هفتم",
                    "action": "/book/8/0/introduction/"
                },
                {
                    "text": "شیمی هفتم",
                    "action": "/book/15/0/introduction/"
                },
                {
                    "text": "زیست هفتم",
                    "action": "/book/16/0/introduction/"
                },
                {
                    "text": "ریاضی هفتم",
                    "action": "/book/17/0/introduction/"
                },
                {
                    "text": "پایتون ۱",
                    "action": "/book/18/0/introduction/"
                },
                {
                    "text": "فرهنگ و هنر هفتم",
                    "action": "/book/40/0/introduction/"
                },
                {
                    "text": "عیدانه هفتم",
                    "action": "/book/49/0/introduction/"
                },
                {
                    "text": "مجموعه کتاب های علوم هفتم",
                    "action": "/book/62/0/introduction/"
                },
                {
                    "text": "مجموعه کتاب های علوم هفتم",
                    "action": "/book/67/0/introduction/"
                },
                {
                    "text": "سی‌پلاس‌پلاس۱",
                    "action": "/book/75/0/introduction/"
                },
                {
                    "text": "تست آزمون ریاضی هفتم",
                    "action": "/book/79/0/introduction/"
                },
                {
                    "text": "اضافه",
                    "action": "/book/new/?category=5"
                }
            ]
        },
        {
            "text": "هشتم",
            "items": [
                {
                    "text": "شیمی هشتم",
                    "action": "/book/1/0/introduction/"
                },
                {
                    "text": "زیست هشتم",
                    "action": "/book/12/0/introduction/"
                },
                {
                    "text": "ریاضی هشتم",
                    "action": "/book/13/0/introduction/"
                },
                {
                    "text": "پایتون ۲",
                    "action": "/book/14/0/introduction/"
                },
                {
                    "text": "فیزیک هشتم",
                    "action": "/book/34/0/introduction/"
                },
                {
                    "text": "عیدانه هشتم",
                    "action": "/book/50/0/introduction/"
                },
                {
                    "text": "مجموعه کتابهای علوم هشتم",
                    "action": "/book/63/0/introduction/"
                },
                {
                    "text": "سی‌پلاس‌پلاس۲",
                    "action": "/book/78/0/introduction/"
                },
                {
                    "text": "اضافه",
                    "action": "/book/new/?category=6"
                }
            ]
        },
        {
            "text": "نهم",
            "items": [
                {
                    "text": "زیست نهم",
                    "action": "/book/4/0/introduction/"
                },
                {
                    "text": "فیزیک نهم",
                    "action": "/book/19/0/introduction/"
                },
                {
                    "text": "شیمی نهم",
                    "action": "/book/20/0/introduction/"
                },
                {
                    "text": "پک جامع دروس نهم",
                    "action": "/book/21/0/introduction/"
                },
                {
                    "text": "آزمونستان ریاضی",
                    "action": "/book/23/0/introduction/"
                },
                {
                    "text": "عیدانه نهم",
                    "action": "/book/52/0/introduction/"
                },
                {
                    "text": "آزمونستان علوم",
                    "action": "/book/53/0/introduction/"
                },
                {
                    "text": "مجموعه کتاب های علوم نهم",
                    "action": "/book/64/0/introduction/"
                },
                {
                    "text": "مجموعه آزمونستان",
                    "action": "/book/65/0/introduction/"
                },
                {
                    "text": "ساندویچ هوش نهم",
                    "action": "/book/69/0/introduction/"
                },
                {
                    "text": "ساندویچ دروس نهم",
                    "action": "/book/73/0/introduction/"
                },
                {
                    "text": "تست آزمون ریاضی نهم",
                    "action": "/book/80/0/introduction/"
                },
                {
                    "text": "سی‌پلاس‌پلاس۳",
                    "action": "/book/84/0/introduction/"
                },
                {
                    "text": "پایتون ۳",
                    "action": "/book/85/0/introduction/"
                },
                {
                    "text": "پک کتاب‌های ساندویچ",
                    "action": "/book/92/0/introduction/"
                },
                {
                    "text": "پک کتاب‌های آزمون ورودی",
                    "action": "/book/93/0/introduction/"
                },
                {
                    "text": "اضافه",
                    "action": "/book/new/?category=7"
                }
            ]
        },
        {
            "text": "دهم",
            "items": [
                {
                    "text": "شیمی دهم",
                    "action": "/book/9/0/introduction/"
                },
                {
                    "text": "هندسه دهم",
                    "action": "/book/24/0/introduction/"
                },
                {
                    "text": "ریاضی دهم",
                    "action": "/book/25/0/introduction/"
                },
                {
                    "text": "فیزیک تجربی",
                    "action": "/book/26/0/introduction/"
                },
                {
                    "text": "فیزیک ریاضی",
                    "action": "/book/27/0/introduction/"
                },
                {
                    "text": "زیست شناسی دهم",
                    "action": "/book/43/0/introduction/"
                },
                {
                    "text": "پاسخ ریاضی دهم",
                    "action": "/book/54/0/introduction/"
                },
                {
                    "text": "پاسخ فیزیک ریاضی",
                    "action": "/book/56/0/introduction/"
                },
                {
                    "text": "پاسخ فیزیک تجربی",
                    "action": "/book/57/0/introduction/"
                },
                {
                    "text": "پاسخ فیزیک ریاضی",
                    "action": "/book/61/0/introduction/"
                },
                {
                    "text": "اضافه",
                    "action": "/book/new/?category=8"
                }
            ]
        },
        {
            "text": "یازدهم",
            "items": [
                {
                    "text": "کارستان فیزیک ریاضی ۱۱",
                    "action": "/book/10/0/introduction/"
                },
                {
                    "text": "حسابان ۱",
                    "action": "/book/28/0/introduction/"
                },
                {
                    "text": "شیمی یازدهم",
                    "action": "/book/38/0/introduction/"
                },
                {
                    "text": "ریاضی ۲ تجربی",
                    "action": "/book/39/0/introduction/"
                },
                {
                    "text": "کارستان فیزیک تجربی ۱۱",
                    "action": "/book/58/0/introduction/"
                },
                {
                    "text": "تستازمون فیزیک ریاضی ۱۱",
                    "action": "/book/59/0/introduction/"
                },
                {
                    "text": "تستآزمون فیزیک تجربی ۱۱",
                    "action": "/book/60/0/introduction/"
                },
                {
                    "text": "اضافه",
                    "action": "/book/new/?category=12"
                }
            ]
        },
        {
            "text": "پیش‌دانشگاهی",
            "items": [
                {
                    "text": "اطلس عربی",
                    "action": "/book/11/0/introduction/"
                },
                {
                    "text": "اطلس دیفرانسیل و انتگرال",
                    "action": "/book/31/0/introduction/"
                },
                {
                    "text": "حساب دیفرانسیل و انتگرال و ریاضیات پایه",
                    "action": "/book/41/0/introduction/"
                },
                {
                    "text": "حساب دیفرانسیل و انتگرال",
                    "action": "/book/42/0/introduction/"
                },
                {
                    "text": "چه چیزی رتبه من را جابه‌جا کرد؟",
                    "action": "/book/86/0/introduction/"
                },
                {
                    "text": "اضافه",
                    "action": "/book/new/?category=13"
                }
            ]
        },
        {
            "text": "غیره",
            "items": [
                {
                    "text": "پک کتاب‌های ساندویچ",
                    "action": "/book/90/0/introduction/"
                },
                {
                    "text": "پک کتاب‌های آزمون ورودی",
                    "action": "/book/91/0/introduction/"
                }
            ]
        }
    ],

}

export const tomMainMenu = {
    "count": 5,
    "next": null,
    "previous": null,
    "results": [
        {
            "id": 49,
            "uri": "/azmuns",
            "title": "آزمون ها",
            "readonly": true,
            "published": true,
            "application": {
                "id": 3,
                "name": "examination-catalogue"
            },
            "order": 1
        },
        {
            "id": 47,
            "uri": "/books",
            "title": "کتاب‌ها",
            "readonly": true,
            "published": true,
            "application": {
                "id": 4,
                "name": "book"
            },
            "order": 2
        },
        {
            "id": 58,
            "uri": "/کلاس‌ها/",
            "title": "کلاس‌ها",
            "readonly": true,
            "published": true,
            "application": null,
            "order": 3
        },
        {
            "id": 37,
            "uri": "/about-us/",
            "title": "درباره‌ ما",
            "readonly": true,
            "published": true,
            "application": null,
            "order": 4
        },
        {
            "id": 46,
            "uri": "/contact-us/",
            "title": "تماس با ما",
            "readonly": true,
            "published": true,
            "application": null,
            "order": 5
        }
    ]
}

export const allComponents = {
    answers: require('../components/answers'),
    analyze_consolidated:require('../components/analyze_consolidated'),
    analyze_shabih_saz_consolidated:require('../components/analyze_shabih_saz_consolidated'),
    book: require('../components/book'),
    book_store_items: require('../components/book_store_items'),
    books: require('../components/books'),
    books_preview: require('../components/books_preview'),
    cart: require('../components/cart'),
    clients: require('../components/clients'),
    clients_map: require('../components/clients_map'),
    comments: require('../components/comments'),
    compilers: require('../components/compilers'),
    double_tree: require('../components/double_tree'),
    essay_report: require('../components/essay_report'),
    examination: require('../components/examination'),
    examination_catalogue: require('../components/examination_catalogue'),
    examination_catalogues: require('../components/examination_catalogues'),
    examination_execution: require('../components/examination_execution'),
    examination_schools: require('../components/examination_schools'),
    examination_store_items: require('../components/examination_store_items'),
    examination_store_items_packs: require('../components/examination_store_items_packs'),
    examination_students: require('../components/examination_students'),
    examinations: require('../components/examinations'),
    free_store_items: require('../components/free_store_items'),
    managers: require('../components/managers'),
    marker: require('../components/marker'),
    markers: require('../components/markers'),
    message: require('../components/message'),
    messages: require('../components/messages'),
    notes: require('../components/notes'),
    online_examination: require('../components/online_examination'),
    orders: require('../components/orders'),
    pages: require('../components/pages'),
    paper: require('../components/paper'),
    papers: require('../components/papers'),
    post_prices: require('../components/post_prices'),
    profile: require('../components/profile'),
    questions: require('../components/questions'),
    registrations: require('../components/registrations'),
    report: require('../components/report'),
    reports: require('../components/reports'),
    results: require('../components/results'),
    schools: require('../components/schools'),
    science_tree: require('../components/science_tree'),
    store: require('../components/store'),
    students: require('../components/students'),
    tree: require('../components/tree'),
    users: require('../components/users'),

    editor_test: require('../components/editor_test'),
    sso_callback : require('../components/sso_callback')
}

export function isPaveRegisted(uri="/"){
    if(uri=='/'){//اگر صفحه اصلی استاتیک می شود، این خط کامنت شود
        return false ;
    }
    for(var route in rawRoutes){
        if(rawRoutes[route].path == uri){
            // debugger
            return true ;
        }
    }
    return false ;
}

export function updateRoutes(newRoutesObject){
    var newRoutes = newRoutesObject.concat();
    for(var i=0 ; i<rawRoutes.length;i++)
    {
        newRoutes.push(rawRoutes[i])
    }
    return newRoutes
}

export const rawRoutes = [
    // {
    //     path: "/",
    //     component: require('../components/static_pages'),
    //     application: "main",
    // },
    {
        path: "/editor/",
        component: "editor_test",
    },
    {
        path: "/sso_callback",
        component : "sso_callback"
    }

]